<div style="display: flex; flex-direction: column; margin-right: 10px">
  <div
    *ngIf="isLoading"
    [style.height.px]="size"
    [style.width.px]="size"
    style="
      display: flex;
      background: var(--ion-color-step-50);
      align-items: center;
      justify-content: center;
      border-radius: 6px;
    "
  >
    <ion-spinner name="crescent" color="primary"></ion-spinner>
  </div>
  <ng-container>
    <a
      *ngIf="!isLoading"
      color="light"
      class="btn-large"
      (click)="
        shouldShowPreview() ? expandPreviewImageForId(id) : downloadFile(id)
      "
      [title]="name"
      style="height: fit-content; width: fit-content"
    >
      <img
        *ngIf="url"
        [src]="url"
        class="depthButton"
        [style.max-height.px]="size"
        style="
          max-width: 100%;
          border-radius: 6px;
          box-shadow: 0px 0px 0px 2px var(--card-shadow-color);
        "
      />
      <ion-button
        color="light"
        *ngIf="!url"
        class="btn-large"
        style="
          width: 64px;
          height: 64px;
          margin-right: 7px;
          --padding-start: 0;
          --padding-end: 0;
        "
      >
        <ion-icon
          slot="icon-only"
          [name]="
            mimetype?.startsWith('video/')
              ? 'play-circle-outline'
              : mimetype === 'application/pdf'
                ? 'document-text-outline'
                : 'download-outline'
          "
        ></ion-icon>
      </ion-button>
    </a>
    <div *ngIf="!isLoading">
      <ion-icon
        *ngIf="!error && id"
        name="download-outline"
        class="icon-padded"
        style="cursor: pointer"
        (click)="downloadFile(id)"
      ></ion-icon>
      <ion-label style="font-size: 12px">{{ shortname }}</ion-label>
    </div>
    <!-- For some reason, 6px is appended to the loaded image, so we try to match that -->
    <!-- Matching the height makes the scrollToBottom actually reach the bottom of page -->
    <div *ngIf="!url && isLoading" style="margin-top: 6px">
      <ion-icon name="ellipsis-horizontal" class="icon-padded"></ion-icon>
      <ion-label *ngIf="!url && isLoading" style="font-size: 12px"
        >Loading...</ion-label
      >
    </div>
  </ng-container>
</div>

<ion-modal
  [isOpen]="previewExpanded"
  (willDismiss)="onDismissPreview()"
  class="image-preview-modal"
>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="onDismissPreview()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>
          <b>{{ previewName }}</b>
        </ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="downloadFile(previewId)">
            <ion-icon name="download-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        "
        (click)="onDismissPreview()"
      >
        <img
          *ngIf="
            !previewLoading &&
            (previewUrl || url) &&
            previewMimetype?.startsWith('image/')
          "
          [src]="previewUrl || url"
          style="max-width: 100%; max-height: 100%"
        />
        <iframe
          *ngIf="
            !previewLoading &&
            previewUrl &&
            previewMimetype === 'application/pdf'
          "
          [src]="previewUrl"
          style="width: 100%; height: 100%; border: none"
          (click)="$event.stopPropagation()"
          (error)="onPdfError($event)"
        ></iframe>
        <video
          *ngIf="
            !previewLoading &&
            previewUrl &&
            previewMimetype?.startsWith('video/')
          "
          [src]="previewUrl"
          controls
          autoplay
          style="max-width: 100%; max-height: 100%"
          (click)="$event.stopPropagation()"
          (error)="onVideoError($event)"
        ></video>
        <div
          *ngIf="
            !previewLoading &&
            !previewUrl &&
            !url &&
            !previewMimetype?.startsWith('image/') &&
            previewMimetype !== 'application/pdf' &&
            !previewMimetype?.startsWith('video/')
          "
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
          "
          (click)="$event.stopPropagation()"
        >
          <ion-icon
            name="document-text"
            style="font-size: 80px; color: var(--ion-color-medium)"
          ></ion-icon>
          <p style="font-size: 16px">{{ previewName }}</p>
          <ion-button (click)="downloadFile(previewId)">
            <ion-icon name="download-outline" slot="start"></ion-icon>
            Download File
          </ion-button>
        </div>
        <ion-spinner name="crescent" *ngIf="previewLoading"></ion-spinner>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
